<template>
    <div>
         <BaseModal
                :ModalId="this.ModalId"
                :HideModalFun="HideModal"
                :TitleWindow="TitleWindow"
                :width="'85%'"
                :height="'auto'"
                :buttons="OpenforClinical ? [
                    { text: 'Cancel', variant: 'secondary', action: 'Close' },
                    { text: 'OK', variant: 'primary', action: OKClick },
                ] : [
                    { text: 'Close', variant: 'primary', action: EmitUpdate },
                ]"
                @Close="Close"
              >


           <Diagnosis :PatientCode="this.PatientCode" :ReadOnly="this.ReadOnly" @onCodeConditionOk="OnCodeConditionOk($event)"></Diagnosis>

        </BaseModal>
    </div>
</template>

<script>
import Diagnosis from  '@/components/pages/patients/Diagnosis'
export default {
 props:{
    PatientCode:String,
    ModalId:String,
    TitleWindow:String,
     OpenforClinical: {
      default: false,
      type: Boolean
    },
    ReadOnly: {
      default: false,
      type: Boolean
    },
  },
  name: 'ModalDiagnosis',
  components:{Diagnosis},
  data(){
    return {
        Diags:""
    }
  },
  methods:{

    OnCodeConditionOk(evt){
        const item = (evt || []).find(x => x.recordId === null) || null;
            if(item!= null && item.diagnoses.length > 0){
                let textResult = '';
                for(var i = 0; i < item.diagnoses.length; i++){
                    textResult = textResult + item.diagnoses[i]['code']+ ' - ' + item.diagnoses[i]['description']+"\n";
                }
                this.Diags = textResult;
            }
    },

    OKClick(){
        this.$emit('UpdateDiagnosis', this.Diags);
    },

    EmitUpdate(){
         this.$emit('UpdateDiagnosis',true);
    },
    HideModal(){
        this.$emit('getCancel');
    },

    Close(){
        this.$emit('getCancel');
    }
  },

  mounted(){

  }

};
</script>


